import { configure, getConsoleSink } from '@logtape/logtape';
export { getLogger } from '@logtape/logtape';

export const setup = async () =>
    await configure({
        sinks: { console: getConsoleSink() },
        loggers: [
            { category: ['logtape', 'meta'], lowestLevel: 'warning', sinks: ['console'] },
            { category: 'app', lowestLevel: 'debug', sinks: ['console'] },
        ],
    });
